import { Button, Chip, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import styled from '@emotion/styled';


export const PopupTitle = styled(DialogTitle)(({ theme }) => `
text-align: center;
font-size: 16px;
padding: 10px 16px;
@media (min-width: 600px){
  padding: 16px 24px;
  font-size: 18px;
  }
`);

export const ContentStyled = styled(DialogContent)(() => `
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
gap: 10px;
padding: 10px 16px;
@media (min-width: 600px){
  padding: 16px 24px;
  }
`);

export const ChipStyled = styled(Chip)(() => `
display: flex;
justify-content: center;
align-items:center;
font-weight: 500;
flex-grow: 1;
width: 40%;
`);


export const CapitalizeWord = styled('span')(({ theme }) => `
text-transform: capitalize;
`);

export const DescriptionStyled = styled.p`
font-size: 14px;
text-align: center;
max-width: 370px;
padding: 0 16px;
text-align:center;
@media (min-width: 600px){
     font-size: 16px;
     padding: 0 24px;
  }
`;

export const WrapperActions = styled(DialogActions)`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
min-width: 100%;
padding: 10px 16px;
@media (min-width: 600px){
  padding: 16px 24px;
  }
`;

export const ButtonStyled = styled(Button)(({ theme, color }) => `
width: 100%;
&:first-of-type {
  margin-left: 0;
}
&:not(:first-of-type) {
  margin-left: 0;
} 
`);



